/**
 * outsideAppointment.js - PROD-1160: the patient's "outside" appointment (source 'manual_external',
 * a visit with a doctor outside Orella, edited in AppointmentEntry) is not an Orella visit. Every
 * finder that picks "the" Orella appointment (reschedule, follow-up reschedule, doctor of the case,
 * initial/follow-up rows) skips it. The API answers 409 outside_appointment_fields_not_allowed when
 * a reschedule PUT on such a row carries status / scheduled_by. Lists the patient reads (visits,
 * AppointmentEntry) keep the row.
 *
 * Import-free on purpose: the gate executes it.
 */
export const isOutsideAppointment = (a) => a?.source === 'manual_external'
